import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { configApi } from "@shared/lib/configApi";
import {
    AllAuthorsResponse,
    Author,
    BlogPostPreview,
    BlogPostsParams,
    BlogPostsResponse
} from "./types";

export const blogApi = createApi({
    reducerPath: "blogApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${configApi.API_URL}/blog-api`
    }),
    endpoints: (builder) => ({
        getBlogPosts: builder.query<BlogPostsResponse, BlogPostsParams>({
            query: ({ page, count, exclude = 0, order = "desc", orderby = "date", author }) => ({
                url: `/posts`,
                params: {
                    _fields:
                        "id,title,slug,date,views,status,x_featured_media_large,author,x_author,x_gravatar",
                    per_page: count,
                    _embed: true,
                    exclude,
                    page,
                    order,
                    orderby,
                    ...(author ? { author } : {})
                }
            }),
            transformResponse: (response: BlogPostPreview[], meta): BlogPostsResponse => {
                const postsCount = Number(meta?.response?.headers.get("x-wp-total")) || 0;
                const pagesCount = Number(meta?.response?.headers.get("X-WP-TotalPages")) || 1;

                return {
                    data: response,
                    postsCount,
                    pagesCount
                };
            }
        }),
        getAllAuthors: builder.query<AllAuthorsResponse, void>({
            query: () => ({
                url: `/users`,
                params: {
                    _fields: "id,name,description,slug"
                }
            }),
            transformResponse: (response: Author[]): AllAuthorsResponse => ({
                data: response
            })
        })
    })
});

export const { useGetBlogPostsQuery, useGetAllAuthorsQuery } = blogApi;